module.exports = __webpack_public_path__ + "static/media/guilherme-soares.f04b122c.jpeg";